import { toggleLogIn, toggleSignUp } from 'js/helpers/loginActions'
export const renderHotelAll = (banner) => {
  const signUpButton = banner.querySelector('.sign-up--button-all-banner')
  const loginButton = banner.querySelector('.log-in--button-all-banner')

  signUpButton.addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()
    toggleSignUp()
  })

  loginButton.addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()
    toggleLogIn()
  })
}
